var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:['px-6 py-4 whitespace-nowrap text-sm text-gray-700', _vm.overflow ? '' : 'overflow-hidden overflow-ellipsis']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }